"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthFacility = void 0;
const class_validator_1 = require("class-validator");
const mocks_1 = require("../../mocks");
const property_1 = require("../../decorators/property");
const constants_1 = require("../../constants");
const file_record_1 = require("../file/file.record");
class HealthFacility extends mocks_1.Model {
}
exports.HealthFacility = HealthFacility;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], HealthFacility.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], HealthFacility.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)({ type: String, enum: constants_1.OfficeTypeEnum }),
    __metadata("design:type", String)
], HealthFacility.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)({ default: 0 }),
    __metadata("design:type", Number)
], HealthFacility.prototype, "visitFeePercentage", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, property_1.Property)({ type: [mocks_1.ObjectId], default: [] }),
    __metadata("design:type", Array)
], HealthFacility.prototype, "priorityDoctorIds", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], HealthFacility.prototype, "iban", void 0);
__decorate([
    (0, property_1.Property)({ type: () => mocks_1.ObjectId, required: false }),
    __metadata("design:type", String)
], HealthFacility.prototype, "imageFileId", void 0);
__decorate([
    (0, property_1.Property)({ type: () => mocks_1.ObjectId, required: false }),
    __metadata("design:type", String)
], HealthFacility.prototype, "wallpaperFileId", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'imageFileId', ref: 'fs.files' }),
    __metadata("design:type", file_record_1.FileRecord)
], HealthFacility.prototype, "imageFile", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'wallpaperFileId', ref: 'fs.files' }),
    __metadata("design:type", file_record_1.FileRecord)
], HealthFacility.prototype, "wallpaperFile", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: '_id', ref: 'User' }),
    __metadata("design:type", Array)
], HealthFacility.prototype, "doctors", void 0);
